export function subdomainCheck() {
    if (getSpaceAliasFromURL() !== ""){
        window.location.replace("/app/");
    }
}

function getSpaceAliasFromURL() {
  const host = window.location.hostname;
  const parts = host.split(".");

  // localhost case
  if (parts.length >= 2 && parts[1].split(":")[0] === "localhost") {
    return parts[0];
  }

  // prod: mandarina.tutaller.com.ar
  if (parts.length >= 3 && parts[0] !== "stg" && parts[1] === "tutaller" && parts[2] === "com") {
    return parts[0];
  }

  // staging: mandarina.stg.tutaller.com.ar
  if (parts.length >= 3 && parts[1] === "stg" && parts[2] === "tutaller") {
    return parts[0];
  }

  // Not a valid space alias
  return "";
}
